export default "__VITE_PUBLIC_ASSET__3445ab98__"